import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { 
  Container, Typography, Paper, Grid, Button, CircularProgress,
  Alert, Divider, Box, Chip, Tabs, Tab, TextField, List, ListItem, ListItemText, IconButton, MenuItem, Select, InputLabel, FormControl,
  Card, CardContent, CardActions, Avatar, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, LinearProgress, Autocomplete, Grow
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import EventNoteIcon from '@mui/icons-material/EventNote';
import DownloadIcon from '@mui/icons-material/Download';
import EventIcon from '@mui/icons-material/Event';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ForumIcon from '@mui/icons-material/Forum';
import SendIcon from '@mui/icons-material/Send';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import FlagIcon from '@mui/icons-material/Flag';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Loading from '../../components/Loading';
import config from '../../config';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const LeadDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [lead, setLead] = useState(null);
  const [loading, setLoading] = useState(true);
  const [qualifying, setQualifying] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const [tabValue, setTabValue] = useState(0);
  const [leadFollowups, setLeadFollowups] = useState([]);
  const [leadConversations, setLeadConversations] = useState([]);
  const [leadDocuments, setLeadDocuments] = useState([]);
  const [leadAssignments, setLeadAssignments] = useState([]);
  const [leadMilestones, setLeadMilestones] = useState([]);

  const [newFollowup, setNewFollowup] = useState('');
  const [newFollowupDesc, setNewFollowupDesc] = useState('');
  const [newFollowupStartDate, setNewFollowupStartDate] = useState('');
  const [newFollowupStartTime, setNewFollowupStartTime] = useState('');
  const [newFollowupEndDate, setNewFollowupEndDate] = useState('');
  const [newFollowupEndTime, setNewFollowupEndTime] = useState('');
  const [newFollowupNextVisitStartDate, setNewFollowupNextVisitStartDate] = useState('');
  const [newFollowupNextVisitStartTime, setNewFollowupNextVisitStartTime] = useState('');
  const [newFollowupNextVisitEndDate, setNewFollowupNextVisitEndDate] = useState('');
  const [newFollowupNextVisitEndTime, setNewFollowupNextVisitEndTime] = useState('');
  const [newFollowupAssignee, setNewFollowupAssignee] = useState('');
  
  const [openFollowupDialog, setOpenFollowupDialog] = useState(false);

  const [newConversation, setNewConversation] = useState('');
  const [newDocument, setNewDocument] = useState('');
  const [newAssignment, setNewAssignment] = useState('');
  const [newMilestone, setNewMilestone] = useState('');
  
  const [users, setUsers] = useState([]);

  const [newMilestoneDate, setNewMilestoneDate] = useState('');
    const [openMilestoneDialog, setOpenMilestoneDialog] = useState(false);
    const [openAssignDialog, setOpenAssignDialog] = useState(false);
    const [assignLoading, setAssignLoading] = useState(false);
    const [uploadingFile, setUploadingFile] = useState(false);

  useEffect(() => {
    fetchLeadDetails();
    fetchUsers();
    fetchFollowups();
    fetchConversations();
    fetchDocuments();
    fetchAssignments();
    fetchMilestones();
  }, [id]);

  const fetchAssignments = async () => {
    try {
      const response = await axios.get(`${config}/leads/${id}/assignments`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setLeadAssignments(response.data);
    } catch (error) {
      console.error('Error fetching assignments:', error);
    }
  };

  const fetchUsers = async () => {
    try {
      const response = await axios.get(`${config}/setup/users`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const fetchFollowups = async () => {
    try {
      const response = await axios.get(`${config}/leads/${id}/followups`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setLeadFollowups(response.data);
    } catch (error) {
      console.error('Error fetching followups:', error);
    }
  };

  const handleAssignUser = async () => {
    setAssignLoading(true);
    try {
      await axios.post(`${config}/leads/${id}/assignments`, {
        user_id: newAssignment,
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setOpenAssignDialog(false);
      setNewAssignment('');
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || "Error assigning user");
    } finally {
      setAssignLoading(false);
    }
  };

  const fetchConversations = async () => {
    try {
      const response = await axios.get(`${config}/leads/${id}/conversations`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setLeadConversations(response.data);
    } catch (error) {
      console.error('Error fetching conversations:', error);
    }
  };

  const fetchDocuments = async () => {
    try {
      const response = await axios.get(`${config}/leads/${id}/documents`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setLeadDocuments(response.data);
    } catch (error) {
      console.error('Error fetching documents:', error);
    }
  };

  const fetchMilestones = async () => {
    try {
      const response = await axios.get(`${config}/leads/${id}/milestones`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setLeadMilestones(response.data);
    } catch (error) {
      console.error('Error fetching milestones:', error);
    }
  };

  const handleAddConversation = async () => {
    if(!newConversation) return;
    try {
      await axios.post(`${config}/leads/${id}/conversations`, { message: newConversation }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setNewConversation('');
      fetchConversations();
    } catch (error) {
      console.error('Error adding conversation:', error);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploadingFile(true);
    // Since leads endpoint doesn't support multipart, but the other does, we will send file metadata
    // Wait, the backend doesn't save raw files yet for leads (no upload handling). 
    // We will save file metadata string as a placeholder for now to mimic the interface until backend supports it.
    try {
      await axios.post(`${config}/leads/${id}/documents`, { file_name: file.name, file_path: `/uploads/${file.name}` }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      fetchDocuments();
    } catch (error) {
      console.error('Error uploading document:', error);
    } finally {
      setUploadingFile(false);
    }
  };

  const handleAddMilestone = async () => {
    if(!newMilestone) return;
    try {
      await axios.post(`${config}/leads/${id}/milestones`, { name: newMilestone, due_date: newMilestoneDate ? new Date(newMilestoneDate).toISOString() : null, status: 'Pending' }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setNewMilestone('');
      setNewMilestoneDate('');
      setOpenMilestoneDialog(false);
      fetchMilestones();
    } catch (error) {
      console.error('Error adding milestone:', error);
    }
  };

  const handleToggleMilestone = async (m) => {
    // Note: requires backend update to actually save, but we will mock UI
    console.log("Toggle milestone not implemented on backend", m);
  };

  const handleDeleteMilestone = async (m) => {
    console.log("Delete milestone not implemented on backend", m);
  };

  const [editingFollowupId, setEditingFollowupId] = useState(null);

  const handleAddFollowup = async () => {
    if (!newFollowup) return;
    try {
      const reminder_date = (newFollowupStartDate && newFollowupStartTime) ? new Date(`${newFollowupStartDate}T${newFollowupStartTime}`).toISOString() : null;
      const date_time_end = (newFollowupEndDate && newFollowupEndTime) ? new Date(`${newFollowupEndDate}T${newFollowupEndTime}`).toISOString() : null;
        const next_visit = (newFollowupNextVisitStartDate && newFollowupNextVisitStartTime) ? new Date(`${newFollowupNextVisitStartDate}T${newFollowupNextVisitStartTime}`).toISOString() : null;
        const next_visit_end = (newFollowupNextVisitEndDate && newFollowupNextVisitEndTime) ? new Date(`${newFollowupNextVisitEndDate}T${newFollowupNextVisitEndTime}`).toISOString() : null;

        const payload = {
          note: newFollowup,
          description: newFollowupDesc,
          reminder_date: reminder_date,
          date_time_end: date_time_end,
          next_visit: next_visit,
          next_visit_end: next_visit_end,
          assigned_to_id: newFollowupAssignee || null
        };

      if (editingFollowupId) {
        await axios.put(`${config}/leads/${id}/followups/${editingFollowupId}`, payload, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
      } else {
        await axios.post(`${config}/leads/${id}/followups`, payload, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
      }

      setNewFollowup('');
      setNewFollowupDesc('');
      setNewFollowupStartDate('');
      setNewFollowupStartTime('');
      setNewFollowupEndDate('');
      setNewFollowupEndTime('');
      setNewFollowupNextVisitStartDate('');
      setNewFollowupNextVisitStartTime('');
      setNewFollowupNextVisitEndDate('');
      setNewFollowupNextVisitEndTime('');
      setNewFollowupAssignee('');
      setEditingFollowupId(null);
      setOpenFollowupDialog(false);
      fetchFollowups();
    } catch (error) {
      console.error('Error adding/updating followup:', error);
    }
  };

  const handleEditFollowup = (f) => {
    setNewFollowup(f.note);
    setNewFollowupDesc(f.description || '');

    if (f.reminder_date) {
        const d = new Date(f.reminder_date);
        setNewFollowupStartDate(d.toISOString().substring(0, 10));
        setNewFollowupStartTime(d.toTimeString().substring(0, 5));
    } else {
        setNewFollowupStartDate('');
        setNewFollowupStartTime('');
    }

    if (f.date_time_end) {
        const de = new Date(f.date_time_end);
        setNewFollowupEndDate(de.toISOString().substring(0, 10));
        setNewFollowupEndTime(de.toTimeString().substring(0, 5));
    } else {
        setNewFollowupEndDate('');
        setNewFollowupEndTime('');
    }

      if (f.next_visit) {
        const nv = new Date(f.next_visit);
        setNewFollowupNextVisitStartDate(nv.toISOString().substring(0, 10));
        setNewFollowupNextVisitStartTime(nv.toTimeString().substring(0, 5));
      } else {
        setNewFollowupNextVisitStartDate('');
        setNewFollowupNextVisitStartTime('');
      }

      if (f.next_visit_end) {
        const nve = new Date(f.next_visit_end);
        setNewFollowupNextVisitEndDate(nve.toISOString().substring(0, 10));
        setNewFollowupNextVisitEndTime(nve.toTimeString().substring(0, 5));
      } else {
        setNewFollowupNextVisitEndDate('');
        setNewFollowupNextVisitEndTime('');
      }

      setNewFollowupAssignee(f.assigned_to_id || '');
      setEditingFollowupId(f.id);
      setOpenFollowupDialog(true);
    };

    const fetchLeadDetails = async () => {
      try {
        const response = await axios.get(`${config}/leads/${id}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        setLead(response.data);
        setError(null);
      } catch (error) {
      console.error('Error fetching lead details:', error);
      setError('Failed to fetch lead details.');
    } finally {
      setLoading(false);
    }
  };

  const handleQualifyLead = () => {
    navigate(`/leads/${id}/convert`);
  };

  if (loading) return <Loading message="Loading Lead Details..." />;

  if (error) return <Alert severity="error" sx={{ mt: 4 }}>{error}</Alert>;
  if (!lead) return <Alert severity="warning" sx={{ mt: 4 }}>Lead not found.</Alert>;

  // Statecode 1 generally means Qualified in Dynamics
  const isQualified = lead?.statecode === 1;

  return (
    <Box sx={{ width: '100%', overflowX: 'hidden', boxSizing: 'border-box', pb: 6, px: { xs: 1, md: 3 }, bgcolor: '#f4f6f8', minHeight: '100vh' }}>
      
      {/* Modern Gradient Header Matches ProjectDetails */}
      <Grow in={true} timeout={500}>
      <Paper elevation={0} sx={{ 
        p: { xs: 3, md: 4 }, 
        mb: 4, 
        mt: 2,
        borderRadius: 4, 
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', 
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
        boxShadow: '0 10px 30px rgba(30, 60, 114, 0.2)'
      }}>
        {/* Background Decorative Circles */}
        <Box sx={{ position: 'absolute', top: -50, right: -50, width: 200, height: 200, borderRadius: '50%', background: 'rgba(255, 255, 255, 0.05)' }} />
        <Box sx={{ position: 'absolute', bottom: -30, left: 100, width: 100, height: 100, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
        
        <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'flex-start', md: 'flex-start' }, justifyContent: 'space-between', gap: 3 }}> 
              <Box sx={{ flex: 1 }}>
                <Button
                  startIcon={<ArrowBackIcon />}
                  onClick={() => navigate('/leads')}
                  sx={{ color: '#90caf9', mb: 2, pl: 0, fontWeight: 'bold', '&:hover': { color: 'white', bgcolor: 'transparent', transform: 'translateX(-4px)' }, transition: 'all 0.2s' }}
                >
                  Back to Leads
                </Button>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1.5 }}>
                  <Avatar sx={{ 
                      width: 52, height: 52, flexShrink: 0,
                      bgcolor: 'rgba(255,255,255,0.15)', 
                      color: '#e3f2fd', 
                      boxShadow: '0 6px 18px rgba(0,0,0,0.2)',
                      border: '2px solid rgba(255,255,255,0.2)',
                  }}>
                    <AssignmentIcon sx={{ color: 'white', fontSize: 26 }} />
                  </Avatar>
                  <Typography variant="h5" fontWeight="900" sx={{ letterSpacing: 0.3, wordBreak: 'break-word', color: 'white', lineHeight: 1.3 }}>
                    {lead.fullname}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', ml: 0.5 }}>
                  <Chip 
                      label={isQualified ? 'Qualified' : 'Open'} 
                      size="small" 
                      sx={{ bgcolor: isQualified ? '#4caf50' : '#ffa726', color: 'white', fontWeight: 700, borderRadius: 1.5 }} 
                  />
                  {lead.companyname && (
                      <Chip 
                          icon={<BusinessIcon sx={{ fontSize: '1rem !important' }} />} 
                          label={`Company: ${lead.companyname}`} 
                          size="small" 
                          sx={{ bgcolor: 'rgba(255,255,255,0.1)', color: 'white', fontWeight: 600, borderRadius: 1.5 }} 
                      />
                  )}
                  {lead.emailaddress1 && (
                      <Chip 
                          icon={<EmailIcon sx={{ fontSize: '1rem !important' }} />} 
                          label={`${lead.emailaddress1}`} 
                          size="small" 
                          sx={{ bgcolor: 'rgba(255,255,255,0.1)', color: 'white', fontWeight: 600, borderRadius: 1.5 }} 
                      />
                  )}
                </Box>
              </Box>

            {/* Action Buttons */}
            <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' }, width: { xs: '100%', md: 'auto' }, pt: { xs: 2, md: 0 }, alignItems: { xs: 'flex-start', md: 'center' } }}>
               <Button 
                variant="contained" 
                color="secondary" 
                size="large"
                startIcon={qualifying ? <CircularProgress size={20} color="inherit"/> : <CheckCircleIcon />}
                onClick={handleQualifyLead}
                disabled={qualifying || isQualified}
                sx={{ 
                  borderRadius: 2, 
                  px: 4, 
                  py: 1.5, 
                  fontWeight: 'bold', 
                  boxShadow: '0 4px 14px rgba(0,0,0,0.2)', 
                  width: { xs: '100%', md: 'auto' },
                  bgcolor: isQualified ? 'rgba(255,255,255,0.2)' : 'white',
                  color: isQualified ? 'white' : '#1e3c72',
                  '&:hover': { bgcolor: isQualified ? 'rgba(255,255,255,0.2)' : '#f0f0f0', transform: 'translateY(-2px)' },
                  transition: 'all 0.2s',
                  height: 'fit-content'
                }}
              >
                {isQualified ? 'Quote Created' : 'Convert to Quote'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Paper>
      </Grow>

      {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 3 }}>{success}</Alert>}

      {/* Main Content Tabs */}
      <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', minHeight: '400px', bgcolor: 'white', border: '1px solid #f0f0f0' }}>
        <Tabs
          value={tabValue}
          onChange={(e, newValue) => setTabValue(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          TabIndicatorProps={{ sx: { height: 3, borderRadius: '3px 3px 0 0' } }}
          sx={{ 
              borderBottom: 1, 
              borderColor: '#f0f0f0', 
              bgcolor: 'white', 
              px: 2,
              '& .MuiTab-root': { fontWeight: 700, textTransform: 'none', minHeight: 64, fontSize: '0.95rem' }
          }}
        >
          <Tab icon={<AssignmentIcon />} label="Details" iconPosition="start" />
          <Tab icon={<CalendarTodayIcon />} label="Followups" iconPosition="start" />
          <Tab icon={<ForumIcon />} label="Conversations" iconPosition="start" />
          <Tab icon={<CloudUploadIcon />} label="Documents" iconPosition="start" />
          <Tab icon={<PersonAddIcon />} label="Assignments" iconPosition="start" />
          <Tab icon={<EventIcon />} label="Milestones" iconPosition="start" />
        </Tabs>

        {/* Details Tab */}
        <TabPanel value={tabValue} index={0}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Grid container spacing={3}>
              {/* Lead Information */}
              <Grid item xs={12} md={8}>
                <Card elevation={0} sx={{ borderRadius: 4, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                  <CardContent sx={{ p: 4, pb: '32px !important' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3, borderBottom: '1px solid #f1f5f9', pb: 2 }}>
                      <BusinessIcon sx={{ color: '#3b82f6' }} />
                      <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Lead Information</Typography>
                    </Box>

                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 600, mb: 0.5 }}>Contact Name</Typography>
                        <Typography variant="body1" sx={{ fontWeight: 700, color: '#0f172a' }}>{lead.firstname} {lead.lastname}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 600, mb: 0.5 }}>Job Title</Typography>
                        <Typography variant="body1" sx={{ fontWeight: 600, color: '#334155' }}>{lead.jobtitle || 'N/A'}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 600, mb: 0.5 }}>Subject (Interest)</Typography>
                        <Typography variant="body1" sx={{ fontWeight: 600, color: '#334155' }}>{lead.subject || 'N/A'}</Typography>
                      </Grid>

                      {lead.quote_ref && (
                        <Grid item xs={12} sm={6}>
                          <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 600, mb: 0.5 }}>Quote Ref</Typography>
                          <Typography variant="body1" sx={{ fontWeight: 600, color: '#334155' }}>{lead.quote_ref}</Typography>
                        </Grid>
                      )}
                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 600, mb: 0.5 }}>Website</Typography>
                        <Typography variant="body1" sx={{ fontWeight: 600, color: '#3b82f6', textDecoration: 'none' }} component="a" href={lead.websiteurl?.startsWith('http') ? lead.websiteurl : `https://${lead.websiteurl}`} target="_blank" rel="noopener noreferrer">
                          {lead.websiteurl || 'N/A'}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 600, mb: 0.5 }}>Country</Typography>
                        <Typography variant="body1" sx={{ fontWeight: 600, color: '#334155' }}>{lead.address1_country || 'N/A'}</Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{ color: '#64748b', fontWeight: 600, mb: 1, mt: 1 }}>Description details</Typography>
                        <Paper elevation={0} sx={{ p: 2.5, bgcolor: "#f8fafc", borderRadius: 3, border: '1px solid #e2e8f0' }}>
                          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', color: '#475569', lineHeight: 1.6, fontWeight: 500 }}>  
                            {lead.description || 'No description explicitly provided by the customer.'}
                          </Typography>
                        </Paper>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Right Sidebar Details */}
              <Grid item xs={12} md={4}>
                <Card elevation={0} sx={{ borderRadius: 4, height: '100%', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9', bgcolor: '#ffffff' }}>
                  <CardContent sx={{ p: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 4, borderBottom: '1px solid #f1f5f9', pb: 2 }}>
                      <PersonAddIcon sx={{ color: '#10b981' }} />
                      <Typography variant="h6" sx={{ fontWeight: 800, color: '#1e293b' }}>Contact Context</Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3.5, gap: 2 }}>
                      <Avatar sx={{ bgcolor: '#eff6ff', color: '#3b82f6', width: 40, height: 40, borderRadius: 2 }}>
                        <EmailIcon fontSize="small" />
                      </Avatar>
                      <Box>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600, display: 'block', mb: 0.5 }}>Email Address</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: '#1e293b' }}>{lead.emailaddress1 || 'N/A'}</Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3.5, gap: 2 }}>       
                      <Avatar sx={{ bgcolor: '#f0fdf4', color: '#10b981', width: 40, height: 40, borderRadius: 2 }}>
                        <PhoneIcon fontSize="small" />
                      </Avatar>
                      <Box>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600, display: 'block', mb: 0.5 }}>Telephone</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: '#1e293b' }}>{lead.telephone1 || lead.mobilephone || 'N/A'}</Typography>
                      </Box>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                      <Avatar sx={{ bgcolor: '#fef2f2', color: '#ef4444', width: 40, height: 40, borderRadius: 2 }}>
                        <DateRangeIcon fontSize="small" />
                      </Avatar>
                      <Box>
                        <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600, display: 'block', mb: 0.5 }}>Captured On</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: '#1e293b' }}>{new Date(lead.createdon).toLocaleString()}</Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Box>
        </TabPanel>

        {/* Followups Tab */}
        <TabPanel value={tabValue} index={1}>
            <Box sx={{ mt: 1, p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4, flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="h5" fontWeight="800" color="#1e293b">Lead Follow-Ups</Typography>
                    <Button 
                        variant="contained" 
                        startIcon={<AddIcon />}
                        onClick={() => {
                            setNewFollowup('');
                              setNewFollowupDesc('');
                              setNewFollowupStartDate('');
                              setNewFollowupStartTime('');
                              setNewFollowupEndDate('');
                              setNewFollowupEndTime('');
                              setNewFollowupNextVisitStartDate('');
                              setNewFollowupNextVisitStartTime('');
                              setNewFollowupNextVisitEndDate('');
                              setNewFollowupNextVisitEndTime('');
                              setNewFollowupAssignee('');
                              setEditingFollowupId(null);
                              setOpenFollowupDialog(true);
                        }} 
                        sx={{ 
                            borderRadius: 2, 
                            fontWeight: 'bold', 
                            px: 3, 
                            boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                            background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                            '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)', background: 'linear-gradient(45deg, #1565c0 0%, #1e88e5 100%)' }
                        }}
                    >
                        Log Follow-up
                    </Button>
                </Box>

            <Box>
                {leadFollowups.length === 0 ? (
                    <Paper elevation={0} sx={{ p: 6, textAlign: 'center', border: '2px dashed #e2e8f0', borderRadius: 4, bgcolor: "#f8fafc" }}>
                        <EventNoteIcon sx={{ fontSize: 64, color: '#cbd5e1', mb: 2 }} />
                        <Typography variant="h6" color="#64748b" fontWeight="700" mb={1}>No follow-ups recorded</Typography>
                        <Typography variant="body2" color="#94a3b8">Log your interactions and upcoming activities with this lead.</Typography>
                    </Paper>
                ) : (
                    <Box sx={{ position: 'relative', pl: { xs: 2.5, md: 5 }, pr: { xs: 1, md: 3 }, '&::before': { content: '""', position: 'absolute', top: 0, bottom: 0, left: { xs: '10px', md: '20px' }, width: '3px', bgcolor: '#e2e8f0', borderRadius: 3, zIndex: 0 }, display: 'flex', flexDirection: 'column', gap: 4 }}>
                        {leadFollowups.map(item => {
    const isAuto = item.note && item.note.startsWith("[Next Visit]");
    return (
        <Box key={item.id} sx={{ position: 'relative', zIndex: 1, mb: 1 }}>
            {/* Timeline Dot */}
            <Box sx={{ position: 'absolute', left: { xs: -24, md: -45 }, top: 24, width: 18, height: 18, borderRadius: '50%', background: isAuto ? 'linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)' : 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)', border: '4px solid #ffffff', boxShadow: '0 0 0 2px #e2e8f0' }} />
            
            <Card elevation={0} sx={{ border: '1px solid', borderColor: isAuto ? '#ede9fe' : '#e2e8f0', borderRadius: 4, transition: 'all 0.3s ease', boxShadow: '0 4px 20px rgba(0,0,0,0.03)', '&:hover': { borderColor: isAuto ? '#c4b5fd' : '#cbd5e1', boxShadow: '0 10px 30px rgba(0,0,0,0.06)', transform: 'translateY(-3px)' }, overflow: 'hidden' }}>
                {/* Header Profile */}
                <Box sx={{ p: 2.5, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, borderBottom: '1px solid', borderColor: isAuto ? '#ede9fe' : '#f1f5f9', background: isAuto ? 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)' : 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', gap: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar sx={{ bgcolor: isAuto ? '#8b5cf6' : '#2563eb', color: 'white', width: 44, height: 44, boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
                            {isAuto ? <AccessTimeIcon /> : <EventNoteIcon />}
                        </Avatar>
                        <Box>
                            <Typography variant="subtitle1" fontWeight="800" color="#1e293b">
                                {item.note && isAuto ? item.note.replace('[Next Visit] ', '') : (item.created_at ? new Date(item.created_at).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : 'No Start Date')} 
                            </Typography>
                            <Box sx={{ mt: 0.5, display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                                {isAuto ? (
                                    <Chip label="Auto-Generated" size="small" sx={{ height: 20, fontSize: '0.65rem', fontWeight: 800, bgcolor: '#e0e7ff', color: '#4f46e5' }} />
                                ) : null}
                                {item.assigned_to_name && (
                                    <Typography variant="caption" color="#64748b" fontWeight="600">
                                        Assignee: <span style={{ color: '#334155' }}>{item.assigned_to_name}</span>
                                    </Typography>
                                )}
                                <Typography variant="caption" color="#94a3b8" fontWeight="500">
                                    • Logged by: {item.created_by_name || 'System'}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button size="small" variant="outlined" startIcon={<EditIcon />} onClick={() => handleEditFollowup(item)} sx={{ borderRadius: 2, fontWeight: 'bold', borderColor: '#cbd5e1', bgcolor: 'white', color: '#475569', '&:hover': { bgcolor: '#f8fafc' } }}>
                            Edit
                        </Button>
                    </Box>
                </Box>

                {/* Body Content */}
                <CardContent sx={{ p: 3, bgcolor: 'white' }}>
                    <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', color: '#334155', lineHeight: 1.6, fontSize: '1rem', mb: 3 }}>
                        {item.description ? (!isAuto ? item.description : item.description.replace('[Next Visit] ', '')) : 'No additional details provided.'}
                    </Typography>

                    {/* Metadata Footer */}
                    { (item.reminder_date || item.date_time_end || item.next_visit || item.next_visit_end) && (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, pt: 2.5, borderTop: '1px dashed #e2e8f0' }}>
                            {item.reminder_date && (
                                <Chip 
                                    icon={<DateRangeIcon fontSize="small" sx={{ color: '#d97706 !important' }} />}
                                    label={`Start: ${new Date(item.reminder_date).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })}`}
                                    sx={{ bgcolor: '#fffbeb', color: '#d97706', fontWeight: 600, borderRadius: 1.5, px: 1, border: '1px solid #fef3c7' }} 
                                />
                            )}
                            {item.date_time_end && (
                                <Chip 
                                    icon={<AccessTimeIcon fontSize="small" sx={{ color: '#d97706 !important' }} />}
                                    label={`End: ${new Date(item.date_time_end).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })}`}
                                    sx={{ bgcolor: '#fffbeb', color: '#d97706', fontWeight: 600, borderRadius: 1.5, px: 1, border: '1px solid #fef3c7' }} 
                                />
                            )}
                            {(item.next_visit || item.next_visit_end) && (
                                <Chip 
                                    icon={<AccessTimeIcon fontSize="small" sx={{ color: '#7c3aed !important' }} />}
                                    label={`Next Visit: ${item.next_visit ? new Date(item.next_visit).toLocaleDateString() : ''} ${item.next_visit_end ? '- ' + new Date(item.next_visit_end).toLocaleDateString() : ''}`}
                                    sx={{ bgcolor: '#f5f3ff', color: '#6d28d9', fontWeight: 700, borderRadius: 1.5, px: 1, border: '1px solid #ede9fe' }} 
                                />
                            )}
                        </Box>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
})}


                    </Box>
                )}
            </Box>
            </Box>
        </TabPanel>

        {/* Conversations Tab */}
        <TabPanel value={tabValue} index={2}>
          <Box sx={{ mt: 1, p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4, flexWrap: 'wrap', gap: 2 }}>
              <Typography variant="h5" fontWeight="800" color="#1e293b">Lead Discussion</Typography>
            </Box>

            <Paper elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: 4, display: 'flex', flexDirection: 'column', height: 600, bgcolor: "#f8fafc", overflow: 'hidden' }}>
              <Box sx={{ flex: 1, overflowY: 'auto', p: { xs: 2, md: 4 }, display: 'flex', flexDirection: 'column', gap: 3 }}>
                {leadConversations.length === 0 && (
                  <Box sx={{ textAlign: 'center', my: 'auto', color: '#94a3b8' }}>
                    <ForumIcon sx={{ fontSize: 64, color: '#cbd5e1', mb: 2 }} />
                    <Typography variant="h6" fontWeight="700" color="#64748b">No discussions yet</Typography>
                    <Typography variant="body2">Be the first to start the conversation.</Typography>
                  </Box>
                )}
                {leadConversations.map((msg) => (
                  <Box key={msg.id} sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, '&:hover .msg-time': { opacity: 1 } }}>
                    <Avatar sx={{ bgcolor: "#3b82f6", width: 40, height: 40, boxShadow: '0 2px 8px rgba(59,130,246,0.3)', fontWeight: 'bold' }}>
                      {msg.created_by_name ? msg.created_by_name.charAt(0).toUpperCase() : 'U'}
                    </Avatar>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', maxWidth: '80%' }}>
                      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, mb: 0.5, ml: 1 }}>
                        <Typography variant="subtitle2" fontWeight="700" color="#334155">{msg.created_by_name || 'User'}</Typography>
                        <Typography className="msg-time" variant="caption" color="#94a3b8" sx={{ opacity: 0.7, transition: 'opacity 0.2s' }}>
                          {new Date(msg.created_at).toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' })}
                        </Typography>
                      </Box>
                      <Paper sx={{ p: 2.5, borderRadius: '20px 20px 20px 4px', bgcolor: 'white', color: '#1e293b', boxShadow: '0 4px 14px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9' }}>
                        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6, fontSize: '0.95rem' }}>
                          {msg.message}
                        </Typography>
                      </Paper>
                    </Box>
                  </Box>
                  ))}
              </Box>

              <Box sx={{ p: 2.5, bgcolor: 'white', borderTop: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: 2 }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Type a message..."
                  value={newConversation}
                  onChange={(e) => setNewConversation(e.target.value)}
                  onKeyPress={(e) => {
                      // Allow multiline if shift is pressed, otherwise send on enter
                      if (e.key === 'Enter' && !e.shiftKey) {
                          e.preventDefault();
                          handleAddConversation();
                      }
                  }}
                  multiline
                  maxRows={4}
                  InputProps={{ 
                      sx: { 
                          borderRadius: 3,
                          bgcolor: "#f8fafc",
                          '& fieldset': { borderColor: '#e2e8f0' },
                          '&:hover fieldset': { borderColor: '#cbd5e1' },
                          '&.Mui-focused fieldset': { borderColor: '#3b82f6', borderWidth: '2px' }
                      } 
                  }}
                />
                <IconButton 
                  onClick={handleAddConversation}
                  disabled={!newConversation.trim()}
                  sx={{ 
                      bgcolor: "#3b82f6", 
                      color: 'white', 
                      width: 48,
                      height: 48,
                      boxShadow: '0 4px 12px rgba(59,130,246,0.3)',
                      transition: 'all 0.2s ease',
                      '&:hover': { bgcolor: '#2563eb', transform: 'scale(1.05)' }, 
                      '&.Mui-disabled': { bgcolor: '#e2e8f0', color: '#94a3b8', boxShadow: 'none' } 
                  }}
                >
                  <SendIcon />
                </IconButton>
              </Box>
            </Paper>
          </Box>
        </TabPanel>

        {/* Documents Tab */}
        <TabPanel value={tabValue} index={3}>
          <Box sx={{ mt: 1, p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4, flexWrap: 'wrap', gap: 2 }}>
              <Typography variant="h5" fontWeight="800" color="#1e293b">Lead Documents</Typography>
              <Button 
                  variant="contained" 
                  startIcon={uploadingFile ? <CircularProgress size={20} color="inherit" /> : <CloudUploadIcon />} 
                  component="label"
                  disabled={uploadingFile}
                  sx={{ 
                      borderRadius: 2, 
                      fontWeight: 'bold', 
                      px: 3, 
                      boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                      background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                      transition: 'all 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)', background: 'linear-gradient(45deg, #1565c0 0%, #1e88e5 100%)' },
                      '&.Mui-disabled': { background: '#94a3b8', color: '#f1f5f9' }
                  }}
              >
                {uploadingFile ? 'Uploading...' : 'Upload Document'}
                <input type="file" hidden onChange={handleFileChange} />
              </Button>
            </Box>

            {leadDocuments.length === 0 ? (
              <Paper 
                  elevation={0} 
                  component="label"
                  sx={{ 
                      p: 8, 
                      textAlign: 'center', 
                      bgcolor: "#f8fafc", 
                      borderRadius: 4, 
                      border: '2px dashed #cbd5e1', 
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      '&:hover': { borderColor: '#3b82f6', bgcolor: '#eff6ff', transform: 'translateY(-2px)' }
                  }}
              >
                <CloudUploadIcon sx={{ fontSize: 64, color: '#94a3b8', mb: 2 }} />
                <Typography variant="h6" color="#334155" fontWeight="700" gutterBottom>No documents found</Typography>
                <Typography variant="body2" color="#64748b" sx={{ mb: 3 }}>
                  Click here to upload specifications, contracts, or other lead files.
                </Typography>
                <Button 
                    variant="contained" 
                    component="span" 
                    sx={{ borderRadius: 2, fontWeight: 'bold', px: 4 }}
                >
                  Browse Files
                </Button>
                <input type="file" hidden onChange={handleFileChange} />
              </Paper>
            ) : (
              <Grid container spacing={3}>
                {leadDocuments.map((doc) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={doc.id}>
                    <Card 
                        elevation={0} 
                        sx={{ 
                            border: '1px solid #e2e8f0', 
                            borderRadius: 4, 
                            display: 'flex', 
                            flexDirection: 'column',
                            height: '100%',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            bgcolor: 'white',
                            '&:hover': { transform: 'translateY(-6px)', boxShadow: '0 12px 24px rgba(0,0,0,0.06)', borderColor: '#93c5fd' }
                        }}
                    >
                      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', pt: 4, pb: 2 }}>
                        <Avatar sx={{ bgcolor: '#eff6ff', color: '#3b82f6', width: 72, height: 72, mb: 2.5, boxShadow: '0 4px 12px rgba(59,130,246,0.15)' }}>
                            <InsertDriveFileIcon sx={{ fontSize: 36 }} />
                        </Avatar>
                        <Tooltip title={doc.file_name} arrow placement="top">
                            <Typography variant="subtitle1" fontWeight="700" color="#1e293b" noWrap sx={{ width: '100%', mb: 1, px: 2 }}>
                                {doc.file_name}
                            </Typography>
                        </Tooltip>
                        <Typography variant="caption" color="#94a3b8" fontWeight="600">
                            {new Date(doc.uploaded_at || Date.now()).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}
                        </Typography>
                      </CardContent>
                      <Divider sx={{ borderColor: '#f1f5f9' }} />
                      <CardActions sx={{ justifyContent: 'center', p: 0 }}>
                        <Button 
                            color="primary"
                            startIcon={<DownloadIcon />} 
                            fullWidth
                            sx={{ 
                                py: 1.5, 
                                borderRadius: '0 0 16px 16px', 
                                fontWeight: '700', 
                                letterSpacing: 0.5,
                                color: '#3b82f6',
                                '&:hover': { bgcolor: '#eff6ff' }
                            }}
                            href={`${config}/leads/${id}/documents/${doc.id}/download`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Download
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                  ))}
              </Grid>
            )}
          </Box>
        </TabPanel>

        {/* Assignments Tab */}
        <TabPanel value={tabValue} index={4}>
          <Box sx={{ mt: 1, p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4, flexWrap: 'wrap', gap: 2 }}>
              <Typography variant="h5" fontWeight="800" color="#1e293b">Team Members</Typography>
              <Button 
                  variant="contained" 
                  startIcon={<PersonAddIcon />} 
                  onClick={() => setOpenAssignDialog(true)} 
                  sx={{ 
                      borderRadius: 2, 
                      fontWeight: 'bold', 
                      px: 3, 
                      boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                      background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                      transition: 'all 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)', background: 'linear-gradient(45deg, #1565c0 0%, #1e88e5 100%)' }
                  }}
              >
                Add Member
              </Button>
            </Box>

            {leadAssignments.length === 0 ? (
                <Paper 
                    elevation={0} 
                    sx={{ 
                        p: 8, 
                        textAlign: 'center', 
                        bgcolor: "#f8fafc", 
                        borderRadius: 4, 
                        border: '2px dashed #cbd5e1'
                    }}
                >
                    <PersonAddIcon sx={{ fontSize: 64, color: '#cbd5e1', mb: 2 }} />
                    <Typography variant="h6" color="#334155" fontWeight="700" gutterBottom>No team members assigned</Typography>
                    <Typography variant="body2" color="#64748b" sx={{ mb: 3 }}>
                      Assign users to this lead to track responsibilities.
                    </Typography>
                    <Button 
                        variant="outlined" 
                        onClick={() => setOpenAssignDialog(true)}
                        sx={{ borderRadius: 2, fontWeight: 'bold', px: 4, borderWidth: 2, '&:hover': { borderWidth: 2 } }}
                    >
                        Assign Someone
                    </Button>
                </Paper>
            ) : (
                <Grid container spacing={3}>
                  {leadAssignments.map((assignment) => (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={assignment.id || assignment.user_id}>
                      <Card 
                        elevation={0}
                        sx={{ 
                          borderRadius: 4,
                          border: '1px solid #e2e8f0',
                          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                          bgcolor: 'white',
                          '&:hover': { transform: 'translateY(-6px)', boxShadow: '0 12px 24px rgba(0,0,0,0.06)', borderColor: '#93c5fd' }
                        }}
                      >
                        <CardContent sx={{ p: 3 }}>
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 1, mb: 3 }}>
                              <Avatar sx={{ bgcolor: '#e0e7ff', color: '#2563eb', fontWeight: '800', width: 64, height: 64, mb: 1, fontSize: '1.5rem', boxShadow: '0 4px 12px rgba(37,99,235,0.15)' }}>
                                {assignment.user_name ? assignment.user_name[0].toUpperCase() : 'U'}
                              </Avatar>
                              <Typography variant="h6" fontWeight="800" color="#1e293b" noWrap sx={{ width: '100%' }}>
                                  {assignment.user_name || `User ID: ${assignment.user_id}`}
                              </Typography>
                              <Chip label="Team Member" size="small" sx={{ height: 24, fontSize: '0.75rem', fontWeight: 700, bgcolor: '#f1f5f9', color: '#475569' }} />
                          </Box>
                          
                          <Divider sx={{ borderColor: '#f8fafc', mb: 2 }} />
                          
                          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <AccessTimeIcon sx={{ fontSize: 16, color: '#94a3b8' }} />
                                  <Typography variant="caption" color="#64748b" fontWeight="600" letterSpacing={0.5}>
                                      ASSIGNED: {new Date(assignment.assigned_at || Date.now()).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}
                                  </Typography>
                              </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                    ))}
                </Grid>
            )}
          </Box>
        </TabPanel>

        {/* Milestones Tab */}
        <TabPanel value={tabValue} index={5}>
          <Box sx={{ mt: 1, p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4, flexWrap: 'wrap', gap: 2 }}>
              <Typography variant="h5" fontWeight="800" color="#1e293b">Lead Milestones</Typography>
              <Button 
                  variant="contained" 
                  startIcon={<AddIcon />} 
                  onClick={() => setOpenMilestoneDialog(true)} 
                  sx={{ 
                      borderRadius: 2, 
                      fontWeight: 'bold', 
                      px: 3, 
                      boxShadow: '0 4px 14px rgba(25,118,210,0.3)',
                      background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                      transition: 'all 0.2s',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 20px rgba(25,118,210,0.4)', background: 'linear-gradient(45deg, #1565c0 0%, #1e88e5 100%)' }
                  }}
              >
                Add Milestone
              </Button>
            </Box>

            <Box sx={{ position: 'relative' }}>
              {leadMilestones && leadMilestones.length > 0 && (
                  <Box 
                      sx={{ 
                          position: 'absolute', 
                          left: 28, 
                          top: 20, 
                          bottom: 20, 
                          width: 3, 
                          bgcolor: '#e2e8f0', 
                          zIndex: 0,
                          display: { xs: 'none', md: 'block' },
                          borderRadius: 2
                      }} 
                  />
              )}
              
              <Grid container spacing={3}>
                  {leadMilestones && leadMilestones.map((milestone) => (
                  <Grid item xs={12} key={milestone.id}>
                      <Card 
                          elevation={0}
                          sx={{ 
                              display: 'flex', 
                              flexDirection: { xs: 'column', md: 'row' },
                              alignItems: { md: 'center' },
                              p: 2.5,
                              borderRadius: 4,
                              border: '1px solid #e2e8f0',
                              bgcolor: 'white',
                              borderLeft: milestone.status === 'Completed' ? '6px solid #10b981' : '6px solid #3b82f6',
                              ml: { md: 6 },
                              position: 'relative',
                              overflow: 'visible',
                              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                              '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 24px rgba(0,0,0,0.06)', borderColor: '#93c5fd' }
                          }}
                      >
                          {/* Timeline Dot */}
                          <Box 
                              sx={{ 
                                  position: 'absolute', 
                                  left: -34 - 7, 
                                  top: '50%', 
                                  transform: 'translateY(-50%)',
                                  width: 20, 
                                  height: 20, 
                                  borderRadius: '50%', 
                                  bgcolor: milestone.status === 'Completed' ? '#10b981' : '#3b82f6',
                                  border: '4px solid white',
                                  boxShadow: '0 0 0 4px #f8fafc, 0 4px 6px rgba(0,0,0,0.1)',
                                  zIndex: 1,
                                  display: { xs: 'none', md: 'block' },
                                  transition: 'all 0.3s'
                              }} 
                          />

                          <Box sx={{ flexGrow: 1, ml: { xs: 0, md: 1 } }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.5 }}>
                                  <Typography variant="h6" fontWeight="800" color="#1e293b">{milestone.name}</Typography>
                                  <Chip 
                                      label={milestone.status === 'Completed' ? 'Completed' : 'In Progress'} 
                                      size="small" 
                                      icon={milestone.status === 'Completed' ? <CheckCircleIcon style={{ color: '#059669' }} /> : <AccessTimeIcon style={{ color: '#2563eb' }} />}
                                      sx={{ 
                                          fontWeight: 700, 
                                          bgcolor: milestone.status === 'Completed' ? '#d1fae5' : '#dbeafe', 
                                          color: milestone.status === 'Completed' ? '#065f46' : '#1e40af',
                                          height: 26,
                                          '& .MuiChip-icon': { 
                                              color: milestone.status === 'Completed' ? '#059669' : '#2563eb' 
                                          }
                                      }}
                                  />
                              </Box>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#64748b', bgcolor: "#f8fafc", px: 1.5, py: 0.5, borderRadius: 2 }}>
                                      <CalendarTodayIcon sx={{ fontSize: 16 }} />
                                      <Typography variant="caption" fontWeight="700" letterSpacing={0.5}>
                                          DUE: {milestone.due_date ? new Date(milestone.due_date).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) : 'No deadline'}
                                      </Typography>
                                  </Box>
                                  {milestone.status !== 'Completed' && (
                                      <Box sx={{ width: 180, flexGrow: { xs: 1, md: 0 } }}>
                                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                              <Typography variant="caption" color="#64748b" fontWeight="600">Timeline Progress</Typography>
                                          </Box>
                                          <LinearProgress 
                                              variant="determinate" 
                                              value={50} 
                                              sx={{ 
                                                  height: 8, 
                                                  borderRadius: 4,
                                                  bgcolor: '#e2e8f0',
                                                  '& .MuiLinearProgress-bar': {
                                                      borderRadius: 4,
                                                      background: 'linear-gradient(90deg, #3b82f6 0%, #60a5fa 100%)'
                                                  }
                                              }} 
                                          />
                                      </Box>
                                  )}
                              </Box>
                          </Box>
                          
                          <Divider orientation="vertical" flexItem sx={{ mx: 3, display: { xs: 'none', md: 'block' }, borderColor: '#f1f5f9' }} />
                          <Divider sx={{ my: 2, display: { xs: 'block', md: 'none' }, borderColor: '#f1f5f9' }} />

                          <Box sx={{ display: 'flex', gap: 1.5, justifyContent: { xs: 'flex-start', md: 'flex-end' }, minWidth: 100 }}>
                              <Tooltip title="Mark Complete" arrow placement="top">
                                  <span>
                                  <IconButton 
                                      disabled={milestone.status === 'Completed'}
                                      onClick={() => handleToggleMilestone(milestone)}
                                      sx={{ 
                                          bgcolor: milestone.status === 'Completed' ? 'transparent' : '#d1fae5', 
                                          color: milestone.status === 'Completed' ? '#cbd5e1' : '#059669',
                                          '&:hover': { bgcolor: '#a7f3d0' }
                                      }}
                                  >
                                      <CheckCircleIcon />
                                  </IconButton>
                                  </span>
                              </Tooltip>
                              <Tooltip title="Delete Milestone" arrow placement="top">
                                  <IconButton 
                                      onClick={() => handleDeleteMilestone(milestone)}
                                      sx={{ 
                                          bgcolor: '#fee2e2', 
                                          color: '#dc2626',
                                          '&:hover': { bgcolor: '#fecaca' }
                                      }}
                                  >
                                      <DeleteIcon />
                                  </IconButton>
                              </Tooltip>
                          </Box>
                      </Card>
                  </Grid>
                    ))}
              </Grid>
            
              {(!leadMilestones || leadMilestones.length === 0) && (
                  <Paper 
                      elevation={0}
                      sx={{ 
                          p: 8, 
                          textAlign: 'center', 
                          bgcolor: "#f8fafc", 
                          borderRadius: 4, 
                          border: '2px dashed #cbd5e1',
                          mt: 2 
                      }}
                  >
                    <FlagIcon sx={{ fontSize: 64, color: '#cbd5e1', mb: 2 }} />
                    <Typography variant="h6" color="#334155" fontWeight="700" gutterBottom>No milestones set</Typography>
                    <Typography variant="body2" color="#64748b" sx={{ mb: 3 }}>
                      Define project checkpoints and tracking dates for this lead.
                    </Typography>
                    <Button 
                        variant="outlined" 
                        startIcon={<AddIcon />} 
                        onClick={() => setOpenMilestoneDialog(true)}
                        sx={{ borderRadius: 2, fontWeight: 'bold', px: 4, borderWidth: 2, '&:hover': { borderWidth: 2 } }}
                    >
                        Add First Milestone
                    </Button>
                  </Paper>
              )}
            </Box>
          </Box>
        </TabPanel>
      </Paper>

      <Dialog open={openAssignDialog} onClose={() => setOpenAssignDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 'bold', borderBottom: '1px solid #f0f0f0', mb: 2 }}>
            Assign Team Member
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 1, minHeight: 200 }}>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                Select a user to assign to this lead. They will receive notifications and updates.
            </Typography>
            <Autocomplete
                fullWidth
                options={users}
                getOptionLabel={(option) => option ? (option.full_name || option.username || '') : ''}
                value={users.find(u => String(u.id) === String(newAssignment)) || null}
                onChange={(event, newValue) => {
                    setNewAssignment(newValue ? newValue.id : '');
                }}
                renderInput={(params) => (
                    <TextField 
                        {...params} 
                        label="Search User" 
                        variant="outlined" 
                    />
                )}
            />
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: '1px solid #f0f0f0' }}>
            <Button onClick={() => setOpenAssignDialog(false)} sx={{ color: '#64748b', fontWeight: 'bold' }}>
                Cancel
            </Button>
            <Button 
                onClick={handleAssignUser} 
                variant="contained" 
                disabled={assignLoading || !newAssignment}
                sx={{ borderRadius: 2, fontWeight: 'bold', px: 3 }}
            >
                {assignLoading ? 'Assigning...' : 'Assign User'}
            </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for Milestones */}
      <Dialog open={openMilestoneDialog} onClose={() => setOpenMilestoneDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 'bold', borderBottom: '1px solid #f0f0f0', mb: 2 }}>
            Add Milestone
        </DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 1 }}>
          <TextField
            autoFocus 
            label="Milestone Name" 
            fullWidth
            variant="outlined"
            value={newMilestone} 
            onChange={(e) => setNewMilestone(e.target.value)}
          />
          <TextField
            label="Due Date" 
            type="date" 
            fullWidth 
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            value={newMilestoneDate} 
            onChange={(e) => setNewMilestoneDate(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, borderTop: '1px solid #f0f0f0' }}>
          <Button onClick={() => setOpenMilestoneDialog(false)} sx={{ color: '#64748b', fontWeight: 'bold' }}>
            Cancel
          </Button>
          <Button 
            onClick={handleAddMilestone} 
            variant="contained" 
            disabled={!newMilestone}
            sx={{ borderRadius: 2, fontWeight: 'bold', px: 3 }}
          >
            Add Milestone
          </Button>
        </DialogActions>
      </Dialog>
      {/* Dialog for Followups */}
      <Dialog open={openFollowupDialog} onClose={() => setOpenFollowupDialog(false)} PaperProps={{ sx: { borderRadius: 4, width: '100%', maxWidth: 700, overflow: 'hidden', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' } }}>
          <Box sx={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', p: 3, display: 'flex', alignItems: 'center', gap: 2, color: 'white' }}>
              <EventNoteIcon sx={{ fontSize: 32, opacity: 0.9 }} />
              <Box>
                  <Typography  variant="h5" sx={{ fontWeight: 800, letterSpacing: 0.5 }}>
                      {editingFollowupId ? 'Edit Follow-up' : 'Log a Follow-up'}
                  </Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8, mt: 0.5 }}>
                      {editingFollowupId ? "Update details for this scheduled interaction." : "Record a new interaction or log an upcoming event."}
                  </Typography>
              </Box>
          </Box>
          <DialogContent sx={{ p: { xs: 2, md: 4 }, bgcolor: '#f8fafc', display: 'flex', flexDirection: 'column', gap: 4 }}>
              
              {/* Core Info */}
              <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0', bgcolor: 'white' }}>
                  <Typography variant="subtitle2" color="#64748b" fontWeight="800" textTransform="uppercase" mb={3}>Interaction Details</Typography>
                  <Grid container spacing={3}>
                      <Grid item xs={12}>
                          <TextField fullWidth label="Title / Short Note *" value={newFollowup} onChange={(e) => setNewFollowup(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                      </Grid>
                      <Grid item xs={12}>
                          <Autocomplete
                              fullWidth
                              options={users}
                              getOptionLabel={(option) => option ? (option.full_name || option.username || '') : ''}
                              value={users.find(u => String(u.id) === String(newFollowupAssignee)) || null}
                              onChange={(e, val) => setNewFollowupAssignee(val ? val.id : '')}
                              renderInput={(params) => <TextField {...params} label="Assign To / Visibility" sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />}
                          />
                      </Grid>
                      <Grid item xs={12}>
                          <TextField fullWidth label="Detailed Description (Optional)" multiline rows={3} value={newFollowupDesc} onChange={(e) => setNewFollowupDesc(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                      </Grid>
                  </Grid>
              </Paper>

              {/* Current Interaction Schedule */}
              <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #e2e8f0', bgcolor: 'white' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                      <DateRangeIcon sx={{ color: '#3b82f6' }} />
                      <Typography variant="subtitle2" color="#1e293b" fontWeight="800" textTransform="uppercase">Current Interaction Timing</Typography>
                  </Box>
                  <Grid container spacing={3}>
                      <Grid item xs={12} sm={3}>
                          <TextField fullWidth type="date" label="Start Date" InputLabelProps={{ shrink: true }} value={newFollowupStartDate} onChange={(e) => setNewFollowupStartDate(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                          <TextField fullWidth type="time" label="Start Time" InputLabelProps={{ shrink: true }} value={newFollowupStartTime} onChange={(e) => setNewFollowupStartTime(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                          <TextField fullWidth type="date" label="End Date" InputLabelProps={{ shrink: true }} value={newFollowupEndDate} onChange={(e) => setNewFollowupEndDate(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                          <TextField fullWidth type="time" label="End Time" InputLabelProps={{ shrink: true }} value={newFollowupEndTime} onChange={(e) => setNewFollowupEndTime(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }} />
                      </Grid>
                  </Grid>
              </Paper>

              {/* Next Visit Schedule */}
              <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid #ede9fe', bgcolor: '#f5f3ff' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                      <AccessTimeIcon sx={{ color: '#7c3aed' }} />
                      <Typography variant="subtitle2" color="#5b21b6" fontWeight="800" textTransform="uppercase">Plan Next Visit</Typography>
                  </Box>
                  <Grid container spacing={3}>
                      <Grid item xs={12} sm={3}>
                          <TextField fullWidth type="date" label="Next Visit Start Date" InputLabelProps={{ shrink: true }} value={newFollowupNextVisitStartDate} onChange={(e) => setNewFollowupNextVisitStartDate(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: 'white' } }} />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                          <TextField fullWidth type="time" label="Next Visit Start Time" InputLabelProps={{ shrink: true }} value={newFollowupNextVisitStartTime} onChange={(e) => setNewFollowupNextVisitStartTime(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: 'white' } }} />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                          <TextField fullWidth type="date" label="Next Visit End Date" InputLabelProps={{ shrink: true }} value={newFollowupNextVisitEndDate} onChange={(e) => setNewFollowupNextVisitEndDate(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: 'white' } }} />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                          <TextField fullWidth type="time" label="Next Visit End Time" InputLabelProps={{ shrink: true }} value={newFollowupNextVisitEndTime} onChange={(e) => setNewFollowupNextVisitEndTime(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, bgcolor: 'white' } }} />
                      </Grid>
                  </Grid>
                  <Typography variant="caption" sx={{ display: 'block', mt: 2, color: '#6d28d9', fontStyle: 'italic', fontWeight: 500 }}>* Automatically creates a dedicated follow-up for the next visit dates provided.</Typography>
              </Paper>

          </DialogContent>
          <DialogActions sx={{ px: 4, py: 3, borderTop: '1px solid #f1f5f9', bgcolor: 'white' }}>
              <Button onClick={() => setOpenFollowupDialog(false)} sx={{ borderRadius: 2, fontWeight: 'bold', color: '#64748b', px: 3 }}>
                  Cancel
              </Button>
              <Button onClick={handleAddFollowup} variant="contained" disabled={!newFollowup} sx={{ borderRadius: 2, fontWeight: 'bold', px: 4, py: 1, boxShadow: 'none', background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',  '&:hover': { boxShadow: '0 4px 12px rgba(25,118,210,0.3)' } }}>
                  {editingFollowupId ? 'Update' : 'Save Follow-up'}
              </Button>
          </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LeadDetails;
